/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkoutSeries = {
  id?: string;
  name?: string;
  externalId?: number;
  dayOfWeek?: WorkoutSeries.dayOfWeek;
  offsetDateTime?: string;
  validUntil?: string;
  boxId?: string;
  scheduleTypeId?: string;
  boxLocationId?: string;
  createdAt?: string;
  updatedAt?: string;
};
export namespace WorkoutSeries {
  export enum dayOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
  }
}

